import React from 'react';
import './MenuShowcase.css';
import DishCard from './DishCard';
import menuItems from './menuData';

function MenuShowcase() {
  return (
    <section className="menu-showcase">
      <div className="menu-showcase__container">
        <h2 className="menu-showcase__title">Our Menu</h2>
        <p className="menu-showcase__pricing">All dishes $5</p>
        <div className="menu-showcase__grid">
          {menuItems.map((dish, index) => (
            <DishCard 
              key={dish.id} 
              dish={dish} 
              loading={index < 2 ? 'eager' : 'lazy'}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default MenuShowcase;
